import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'embed-url',
  templateUrl: './embed.component.html',
  styleUrls: ['./embed.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EmbedComponent {
  @Input() embed: any;

  constructor() {}

  getEmbedStyles() {
    return {
      ...(this.embed.background != null && { background: this.embed.background }),
      ...(this.embed.color != null && { color: this.embed.color }),
      ...(this.embed.className != null && { className: this.embed.className }),
    };
  }
}
